import React, {useEffect, useState } from 'react';
import queryString  from 'query-string';
import { BrowserRouter as Router, Route, Switch, Redirect, useLocation } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import PropTypes from 'prop-types';
import { CloseButton, Fade } from '../components/common/Toast';
import loadable from '@loadable/component';
import { AuthProvider, useAuthDispatch } from '../context';
import AppRoutes from './AppRoutes';
import Error404 from '../components/errors/Error404';
import Home from '../components/pages/kitchen/home'
import ForgetPwd from '../components/pages/kitchen/auth/forgetPwd';
import ResetPwd from '../components/pages/kitchen/auth/resetPwd';
import { loginWithSingleSignin } from '../actions/authAction';
import withRedirect from '../hoc/withRedirect';

const Login=loadable(()=>import('../components/pages/kitchen/auth/login'));
const PrivacyPolicy = loadable(() => import('./PrivacyPolicy'));

const routes = [
	{
		path: '/login',
		component: Login,
		isPrivate: false,
	},
  {
		path: '/404',
		component: Error404,
		isPrivate: false,
	},
  {
		path: '/privacy-policy',
		component: PrivacyPolicy,
		isPrivate: false,
	},
  {
		path: '/forgotPassword',
		component: ForgetPwd,
		isPrivate: false,
	},
	{
		path: '/reset',
		component: ResetPwd,
		isPrivate: false,
	},
	{
		path: '/activate',
		component: ResetPwd,
		isPrivate: false,
	},	
	 {
		path: '/*',
		component: Home,
		isPrivate: true,
	},
];

const Layout = () => {
	const location =useLocation();
	const [loadable, setLoading]=useState(false);
	const dispatch = useAuthDispatch();
   // let devRespData = {};
   useEffect(()=>{
    validateToken();
	Login.preload();    
  },[]);
  const validateToken=async ()=>{
    console.log(location);
	await setLoading(true);
    const perms=queryString.parse(atob(location.search.substring(1, location.search.length)));
	const {akey, rkey, sid}=perms
	if(Object.keys(perms).length>0){
		const reqObj={access_token:akey, 
			refresh_token:rkey, 
			id:(sid||0),
			scope: "read write",
			token_type: "bearer",
			singleLogin:true
		};
		const result=await loginWithSingleSignin(dispatch,reqObj);
		setLoading(false);
		if(!result.error){
			window.location.href=location.pathname;
		}else{
			toast.error(result.errorMessage);
			//props.history.push('/login');

		}
	}
}

  return (
    <Router>
      <Switch>
      {routes.map((route) => (
						<AppRoutes
							key={route.path}
							path={route.path}
							component={route.component}
							isPrivate={route.isPrivate}
						/>
					))} 
      </Switch>
      <ToastContainer transition={Fade} closeButton={<CloseButton />} position={toast.POSITION.TOP_CENTER} />
    </Router>);
};
Layout.propTypes = {
	setRedirect: PropTypes.func.isRequired,
	layout: PropTypes.string,
	hasLabel: PropTypes.bool
  };

export default withRedirect(Layout);
